module.exports = __webpack_public_path__ + "static/media/issue_pragati_review.2477760e.svg";